// controls/staticTitle.js — bloc statique titre / sous-titre
import React, { useEffect, useState } from "react";


/**
 * Création d’un bloc statique "Titre / Sous-titre"
 * non validable (x-static = true)
 */
export function createStaticTitleField() {
  return {
    type: "object",
    title: "Titre / Sous-titre",
    "x-ui": "staticTitle",
    "x-static": true,
    properties: {
      heading: {
        type: "string",
        default: "h2",
      },
      title: {
        type: "string",
        default: "Titre principal"
      },
      subtitle: {
        type: "string",
        default: ""
      }
    }
  };
}

/**
 * Éditeur du bloc Titre / Sous-titre
 */
export function EditStaticTitleField({ field, onChange }) {
  const [heading, setHeading] = useState(
    field.properties?.heading?.default || "h2"
  );
  const [title, setTitle] = useState(field.properties?.title?.default || "");
  const [subtitle, setSubtitle] = useState(
    field.properties?.subtitle?.default || ""
  );

  // 🔄 synchronise vers le builder
  useEffect(() => {
    const updated = {
      ...field,
      properties: {
        ...field.properties,
        heading: { ...field.properties.heading, default: heading },
        title: { ...field.properties.title, default: title },
        subtitle: { ...field.properties.subtitle, default: subtitle }
      }
    };
    onChange(updated);
  }, [heading, title, subtitle]);

  return (
    <div>
      <div className="d-flex align-items-center gap-2 mb-3">

        <h6 className="m-0">Bloc de titre / sous-titre</h6>
      </div>

      {/* Niveau de titre */}
      <div className="mb-3">
        <label className="form-label">Niveau de titre (balise HTML)</label>
        <select
          className="form-select form-select-sm"
          value={heading}
          onChange={(e) => setHeading(e.target.value)}
        >
          {["h1", "h2", "h3", "h4", "h5", "h6"].map((lvl) => (
            <option key={lvl} value={lvl}>
              {lvl.toUpperCase()}
            </option>
          ))}
        </select>
      </div>

      {/* Titre principal */}
      <div className="mb-3">
        <label className="form-label">Titre principal</label>
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="Ex. Informations générales"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>

      {/* Sous-titre optionnel */}
      <div className="mb-3">
        <label className="form-label">Sous-titre (optionnel)</label>
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="Texte complémentaire"
          value={subtitle}
          onChange={(e) => setSubtitle(e.target.value)}
        />
      </div>
    </div>
  );
}

export const editStaticTitleField = (props) => <EditStaticTitleField {...props} />;


/* =========================================================
   🧩 FRONT — rendu du bloc statique (Titre / Sous-titre)
   ========================================================= */
export const RenderStaticTitleField = ({ field }) => {
  const headingTag = field.properties?.heading?.default || "h2";
  const title = field.properties?.title?.default || "";
  const subtitle = field.properties?.subtitle?.default || "";
  const Heading = headingTag;

  return (
    <div className={`fb-field fb-static-title ${field["x-bloc-class"] || ""}`}>
      {title && <Heading className={field["x-control-class"] || ""}><span>{title}</span></Heading>}
      {subtitle && <p className="text-muted mb-0">{subtitle}</p>}
    </div>
  );
};
